import React from "react";
import AudienceStepIndicator from "./AudienceStepIndicator";

const AudienceFlowHeader = ({ steps, title = "Create Audience", subtitle = "Build a clean, campaign-ready contact list in a few steps.", onBack }) => (
  <div className="tw-w-full">
    <div className="tw-flex tw-items-center tw-gap-3.5 tw-pb-3">
      <div className="tw-flex tw-h-[44px] tw-w-[44px] tw-items-center tw-justify-center tw-rounded-[12px] tw-bg-gradient-to-b tw-from-[#8B70FF] tw-to-[#5D44FF] tw-text-white tw-flex-shrink-0 tw-shadow-sm">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <rect x="3" y="6" width="18" height="12" rx="3"></rect>
          <path d="M7 10h5"></path>
          <path d="M7 14h7"></path>
          <circle cx="17" cy="12" r="2"></circle>
        </svg>
      </div>
      <div>
        <h1 className="tw-m-0 tw-text-[20px] tw-font-semibold tw-text-[#2E2C27] tw-font-poppins">
          {title}
        </h1>
        <p className="tw-m-0 tw-mt-0.5 tw-text-[13.5px] tw-font-normal tw-text-[#65686F]">
          {subtitle}
        </p>
      </div>
    </div>

    <div className="tw-py-4 tw-flex tw-justify-center">
      {steps.map((step, index) => {
        const nextStep = steps[index + 1];
        const lineActive = nextStep && (nextStep.state === "done" || nextStep.state === "current");
        return (
          <AudienceStepIndicator
            key={step.number}
            number={step.number}
            label={step.label}
            state={step.state}
            lineActive={lineActive}
            isLast={index === steps.length - 1}
          />
        );
      })}
    </div>
  </div>
);

export default AudienceFlowHeader;
